import toolkitApi, { toolkitSimpleTransform } from '../../toolkitApi';

const metaEndpoint = (args) =>
    `/site/api/meta-data/${args.formattedPath}${args.season !== undefined ? `?season=${args.season}` : ''}`;

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        meta: build.query({
            query: (args) => ({
                url: metaEndpoint(args),
            }),
            transformResponse: toolkitSimpleTransform,
        }),
    }),
});
